import { EditTableThemeModeConfig } from './types';

const light: EditTableThemeModeConfig = {
  EditTable: {
    backgroundColor: '#e0e0e0',
    backgroundGradient: 'linear-gradient(to bottom, #33adff11, #ffffff)',
    cardBackgroundGradient: 'linear-gradient(to bottom, #33adff55, #0000FF22)',
    hoverBackgroundGradient: 'linear-gradient(to bottom, #33adff99, #0000FF22)',
    borderColor: ' #ddf ',
    boxShadow: '0 8px 12px 0 #80ccff, 0 8px 12px #33adff, 8px 10px 12px 0 #33adff',
    textColor: '#444444',
    textColorLight: ' #333',
    labelBGColor: '#50521120',
    normalButtonBGColor: '#0775bc',
    normalButtonBorderColor: '2px solid #267DAC',
    backgroundColorLight: '#e6e6e6',
    backgroundColorDark: '#f6f6f6',
    hoverBackgroundColor:'#f0f0f0',
    hoverBckgroundCellColor: '#f9f9f9'
  },
};

export default light;
